// extracted by mini-css-extract-plugin
export default {"table":"MatchingTable_table__V7LnR"};